

// header sticky position

document.addEventListener('DOMContentLoaded', function() {
  const header = document.querySelector('.section-header');
  const borderOffset = document.querySelector('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
  const headerBottomPosition = header.getBoundingClientRect().bottom - borderOffset;
  document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerBottomPosition)}px`);
});


// collection facets dropdown


const filterButton = document.getElementById('filter-button');
const facetFilters = document.getElementById('facet-filters');

filterButton.addEventListener('click', (e) => {
  e.preventDefault();
  facetFilters.style.display = facetFilters.style.display === 'block' ? 'none' : 'block';
});

document.addEventListener('click', (e) => {
  if (facetFilters.style.display === 'block' && !facetFilters.contains(e.target) && !filterButton.contains(e.target)) {
    facetFilters.style.display = 'none';
  }
});
